import { useRef, useState } from 'react';

export const useEnquiry = (kind) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [receipt, setReceipt] = useState(null);
  const lastRequest = useRef(null);
  const inFlight = useRef(false);
  const submit = async (payload, cv) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    setError('');
    const signature = JSON.stringify([kind, payload, cv && [cv.name, cv.size, cv.lastModified]]);
    if (lastRequest.current?.signature !== signature) lastRequest.current = { signature, id: crypto.randomUUID() };
    const body = new FormData();
    body.append('request_id', lastRequest.current.id);
    body.append('data', JSON.stringify(payload));
    if (cv) body.append('cv', cv);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 90000);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/forms/${kind}`, { method: 'POST', body, signal: controller.signal });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof result.detail === 'string' ? result.detail : 'L’envoi a échoué. Veuillez réessayer.');
      setReceipt(result);
    } catch (failure) {
      setError(failure.name === 'AbortError' ? 'Le serveur met plus de temps que prévu. Réessayez : votre demande ne sera pas enregistrée deux fois.' : failure.message === 'Failed to fetch' ? 'Connexion interrompue. Vérifiez votre connexion puis réessayez.' : failure.message);
    } finally {
      clearTimeout(timeout);
      inFlight.current = false;
      setBusy(false);
    }
  };
  return { busy, error, receipt, submit };
};